import React from 'react';
import RGBBackground from './RGBBackground';

export default function AuthLayout({ children }) {
    return (
        <div className="relative min-h-screen text-slate-100 selection:bg-cyber-blue/30 selection:text-white">
            <RGBBackground />
            <main className="relative z-10">{children}</main>
        </div>
    );
}
